(function () {
  var SELECTORS = {
    hero: '#pext-3xcwy',
    legacyNewArrivals: '#pext-oyb2h',
    b2bBanner: '#shopify-section-yieon-home-b2b-banner',
    newArrivals: '.yieon-home-products--new-arrivals',
    reviews: '#shopify-section-reviews-showcase',
    craftHeading: '#pext-o3rkb',
    craftBand: '#pext-qp5ml',
    legacyBestSellers: '#pext-ds3bz',
    bestSellers: '.yieon-home-products--best-sellers',
    brandStory: '#pext-vnzeo',
    lastChance: '.yieon-home-products--last-chance'
  };

  function find(selector) {
    return document.querySelector(selector);
  }

  function addLookbookClasses() {
    document.body.classList.add('yieon-lookbook-home');

    Object.keys(SELECTORS).forEach(function (key) {
      var element = find(SELECTORS[key]);
      if (element) element.classList.add('yieon-lookbook-' + key.replace(/[A-Z]/g, function (letter) {
        return '-' + letter.toLowerCase();
      }));
    });
  }

  function placeAfter(element, reference) {
    if (!element || !reference || !reference.parentNode) return;
    if (reference.nextElementSibling === element) return;
    reference.parentNode.insertBefore(element, reference.nextSibling);
  }

  function enforceHomepageOrder() {
    var legacyNewArrivals = find(SELECTORS.legacyNewArrivals);
    var b2bBanner = find(SELECTORS.b2bBanner);
    var newArrivals = find(SELECTORS.newArrivals);
    var reviews = find(SELECTORS.reviews);
    var bestSellers = find(SELECTORS.bestSellers);
    var legacyBestSellers = find(SELECTORS.legacyBestSellers);
    var lastChance = find(SELECTORS.lastChance);

    if (legacyNewArrivals) legacyNewArrivals.hidden = true;
    if (legacyBestSellers) legacyBestSellers.hidden = true;
    var heroAnchor = legacyNewArrivals || find(SELECTORS.hero);
    placeAfter(b2bBanner, heroAnchor);
    placeAfter(newArrivals, b2bBanner || heroAnchor);
    placeAfter(bestSellers, newArrivals);
    placeAfter(reviews, bestSellers);
    placeAfter(lastChance, reviews);
  }

  function labelCraftLinks() {
    var labels = ['Lacquer', 'Filigree', 'Mother-of-Pearl', 'Tie-dye', 'Song Brocade', 'Shu Painting', 'Kesi', 'Knot'];
    var ids = ['pext-tp7lb', 'pext-rk718', 'pext-ikvtv', 'pext-aa6n2', 'pext-2rq52', 'pext-6uzxo', 'pext-iglby', 'pext-zf9fr'];

    ids.forEach(function (id, index) {
      var card = document.getElementById(id);
      if (!card) return;
      card.setAttribute('data-craft-label', labels[index]);
      var link = card.querySelector('a');
      if (link && !link.getAttribute('aria-label')) link.setAttribute('aria-label', labels[index]);
    });
  }

  function replaceHeading(selector, firstLine, secondLine) {
    var heading = document.querySelector(selector);
    if (!heading) return;

    heading.textContent = firstLine;
    if (secondLine) {
      heading.appendChild(document.createElement('br'));
      heading.appendChild(document.createTextNode(secondLine));
    }
  }

  function updateHeroLink(selector) {
    var wrapper = document.querySelector(selector);
    if (!wrapper) return;

    Array.prototype.forEach.call(wrapper.querySelectorAll('a'), function (link) {
      link.setAttribute('href', '/collections/crystal-fireworks');
      link.removeAttribute('target');
    });
  }

  function updateCrystalFireworksHero() {
    var hero = find(SELECTORS.hero);
    if (!hero) return;

    var topLevelList = hero.querySelector(
      ':scope > .pe-pirate > .pe-slider > .splide > .pe-slider-track-wrapper > .splide__track > .splide__list'
    );
    if (topLevelList) {
      var slides = Array.prototype.filter.call(topLevelList.children, function (slide) {
        return !slide.classList.contains('splide__slide--clone');
      });

      slides.forEach(function (slide, index) {
        var isPrimary = index === 0;
        slide.classList.toggle('yieon-hero-primary', isPrimary);
        slide.setAttribute('aria-hidden', isPrimary ? 'false' : 'true');
      });
    }

    replaceHeading('#pext-29127 .pe-heading', 'CRYSTAL FIREWORKS');
    replaceHeading('#pext-v5juf .pe-heading', 'Fireworks fade.', 'Heartbeats last forever.');
    updateHeroLink('#pext-7p94f');

    replaceHeading('#pext-dzoog .pe-heading', 'CRYSTAL FIREWORKS');
    replaceHeading('#pext-aja07 .pe-heading', 'Fireworks fade.', 'Heartbeats last forever.');
    updateHeroLink('#pext-m422t');

    replaceHeading('#pext-51i83 .pe-heading', 'CRYSTAL FIREWORKS');
    replaceHeading('#pext-dzqki .pe-heading', 'Fireworks fade.', 'Heartbeats last forever.');
    updateHeroLink('#pext-g9u2i');
  }

  function initializeLookbook() {
    addLookbookClasses();
    enforceHomepageOrder();
    updateCrystalFireworksHero();
    labelCraftLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLookbook, { once: true });
  } else {
    initializeLookbook();
  }

  document.addEventListener('shopify:section:load', initializeLookbook);
})();
